import {store} from "../../../../redux/store";
import {musicHomeSlice} from "./musicHomeSlice";

export const musicHomeStore = {
  // State modifiers
  resetAndCloseSearch: () => {
    // clear search
    store.dispatch(musicHomeSlice.actions.resetFilterSearchReducer());
    // TODO: Not sure this line is a good idea. Stores probably should reference each other to avoid circular dependencies.
    //  Also, mobile.search value should probably be pulled through a store facade.
    const isMobileSearchMenuOpen = store.getState().mySongsPage.activeMenu?.includes('mobile.search');
    if (isMobileSearchMenuOpen) {
      // is open, close
      store.dispatch(musicHomeSlice.actions.removeActiveMenuReducer('mobile.search'));
    }
  },
  setSearchFieldFocus: (isFocused: boolean) => store.dispatch(musicHomeSlice.actions.setSearchFieldFocusReducer(isFocused)),
  setSearchFieldValue: (value: string) => store.dispatch(musicHomeSlice.actions.filterSearchSetValueReducer(value)),
  toggleMobileSearchControls: () => store.dispatch(musicHomeSlice.actions.toggleActiveMenuReducer('mobile.search')),

  // Getters
  doesMobileSearchHaveText: (): boolean => musicHomeSlice.selectors.doesMobileSearchFieldHaveTextSelector(store.getState()),
  getSearchText: (): string => musicHomeSlice.selectors.searchTextSelector(store.getState()),
  isMobileSearchActive: (): boolean => musicHomeSlice.selectors.isMobileSearchFieldActiveSelector(store.getState()),
  isSearchFieldFocused: (): boolean => musicHomeSlice.selectors.isSearchFieldFocusedSelector(store.getState()),
}